import { FunctionComponent, PropsWithChildren, useEffect, useRef } from 'react';
import { Header } from '../header';
import { SideLinks } from '../side-links';

export const Layout: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const divRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const handleScroll = () => {
      const div = divRef.current;

      // Check if the user has scrolled to the bottom
      if (div && div.scrollTop + div.clientHeight === div.scrollHeight) {
        debugger;
        console.log('Scrolled to the bottom!');
        // Perform any actions you want when the user reaches the bottom
      }
    };

    // Attach the scroll event listener to the div
    const div = divRef.current;
    if (div) {
      // debugger;
      div.addEventListener('scroll', handleScroll);
    }

    // Clean up the event listener when the component unmounts
    return () => {
      if (div) {
        div.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <>
      <Header />
      <div ref={divRef}>
      {children}
      </div>
      <SideLinks />
      {/* <Footer /> */}
    </>
  );
};
